import {
  ExpandSearchItem,
  GalleryCTAItem,
  GalleryPlaceholder,
  GeoboostItem,
  ListingPlugin,
} from '@/shared/models';
import { all } from '@/shared/models/ListingPlugins/matchers';
import {
  afterGalleryAndCompleteRowPosition,
  endOfListing,
  galleryPosition,
} from '@/shared/models/ListingPlugins/position';
import { generateADVItems } from '@/tools/listingPlugins/utils';

const buildPlugins = (
  columnCount: number,
  galleryCount: number
): ListingPlugin[] => [
  {
    model: new GalleryPlaceholder(),
    categories: all(),
    position: galleryPosition(),
  },
  {
    model: new GeoboostItem(),
    categories: all(),
    position: afterGalleryAndCompleteRowPosition(columnCount, galleryCount),
  },
  {
    model: new GalleryCTAItem(),
    categories: all(),
    position: afterGalleryAndCompleteRowPosition(columnCount, galleryCount),
    addToListing: (_, galleryCount) => galleryCount > 0,
  },
  {
    model: new ExpandSearchItem(),
    categories: all(),
    position: endOfListing(),
    addToListing: (_, __, searchAdsCount) => searchAdsCount < 5,
  },
];

/**
 * Function providing an array containing all the plugins that should be added to the listing.
 */
export const providePlugins = (
  advFrequency: number,
  pageAdsCount: number,
  columnCount = 1,
  galleryCount = 0
): ListingPlugin[] => [
  ...buildPlugins(columnCount, galleryCount),
  ...generateADVItems(pageAdsCount, advFrequency, columnCount, galleryCount),
];
